import { CrudService } from './CrudService';
import { resources } from '../resources';
import { SupplierEmployeeDto } from '../models/suppliers/SupplierEmployeeDto';
import { SupplierEmployeeQueryParams } from '../params/SupplierEmployeeQueryParams';
import { CompanySupplierEmployeeQueryParams } from '../params/CompanySupplierEmployeeQueryParams';
import { Args, AxiosPagePromise } from './BaseService';
import { AxiosPromise, type RawAxiosRequestConfig } from 'axios';
import { SupplierCertDto } from '../models/suppliers/SupplierCertDto';
import { SupplierDto } from '../models/suppliers/SupplierDto';
import { Page } from '../models/common/Page';
import { PinResponse } from '../models/suppliers/PinResponse';
import { InvitationPersonStatusResponse } from '../models/invitation/InvitationPersonStatusResponse';
import { BaseSearchParams } from '../params/BaseSearchParams';
import { SupplierEmployeeCertificateQueryParams } from '../params/SupplierEmployeeCertificateQueryParams';

export class SupplierEmployeeService extends CrudService<SupplierEmployeeDto, SupplierEmployeeQueryParams> {
  constructor() {
    super({
      query: resources.querySupplierEmployees,
      get: resources.getSupplierEmployee,
      create: resources.createSupplierEmployee,
      update: resources.updateSupplierEmployee,
      idKey: 'employeeId',
    });
  }

  public updateVisitorToSupplierEmployee(supplierId: string, employeeId: string, body: SupplierEmployeeDto, args?: Args): AxiosPromise<void> {
    return this.post<void>(resources.updateVisitorToSupplierEmployee, body, { employeeId, supplier: supplierId, ...args });
  }

  public getSupplierEmployeeProtocol(employeeId: string, args?: Args): AxiosPromise<Blob> {
    return this.get<Blob>(resources.getSupplierEmployeeProtocol, { employeeId, ...args }, { responseType: 'blob' });
  }

  public revealPin(employeeId: string, invitationId?: string, args?: Args): AxiosPromise<PinResponse> {
    return this.get<PinResponse>(resources.revealPin, { employeeId, invitation: invitationId, ...args });
  }

  public getCertificates(employeeId: string, args?: SupplierEmployeeCertificateQueryParams, options: RawAxiosRequestConfig = {}): AxiosPagePromise<SupplierCertDto> {
    return this.get<Page<SupplierCertDto>>(resources.getCertificates, { employeeId, ...args }, options);
  }

  public getSupplierFromUserId(userId: string, args?: Args): AxiosPromise<SupplierDto> {
    return this.get<SupplierDto>(resources.getSupplierFromUserId, { userId, ...args });
  }

  public getInvitationsData(
    employeeId: string,
    args?: BaseSearchParams,
    options: RawAxiosRequestConfig = {},
  ): AxiosPagePromise<InvitationPersonStatusResponse> {
    return this.get<Page<InvitationPersonStatusResponse>>(resources.getInvitationsData, { employeeId, ...args }, options);
  }

  public querySupplierEmployeesByCompany(
    args?: CompanySupplierEmployeeQueryParams,
    options: RawAxiosRequestConfig = {},
  ): AxiosPagePromise<SupplierEmployeeDto> {
    return this.get<Page<SupplierEmployeeDto>>(resources.querySupplierEmployeesByCompany, { ...args }, options);
  }
}
